import { render, staticRenderFns } from "./book_catalogue.vue?vue&type=template&id=5273fdd3&scoped=true&"
import script from "./book_catalogue.vue?vue&type=script&lang=js&"
export * from "./book_catalogue.vue?vue&type=script&lang=js&"
import style0 from "./book_catalogue.vue?vue&type=style&index=0&id=5273fdd3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5273fdd3",
  null
  
)

export default component.exports